import React, { useEffect, useCallback, useContext } from 'react';
import { Select, RimlessSelect } from '@byte-design/ui';
import { observer } from 'mobx-react';
import styles from './index.module.scss';
import { DownOne, Right } from '@icon-park/react';
import { debounce } from 'lodash';
import { globalInfoStoreContext } from '@/models/global';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import { TeamListData, OpensceneData } from '@/typings/common';
import { useUrlSerach } from '@/utils/hooks/common';

interface Props{
  type: string;
  list: any[];
}
const SelectMore: React.FC<Props> = ({
  type, list,
}) => {
  const { t } = useTranslation();
  const golbal = useContext(globalInfoStoreContext);
  const { activeTeamId, activeOpensceneId } = golbal;
  const value = type === 'team' ? activeTeamId : activeOpensceneId;
  const history = useHistory();

  const createScrollEvent = useCallback((ref) => {
    if (ref) {
      ref.addEventListener('scroll', debounce(async () => {
        if (ref.clientHeight + ref.scrollTop >= ref.scrollHeight) {
          // eslint-disable-next-line no-console
          console.log('end');
        }
      }, 30));
    }
  }, []);

  useEffect(() => {
    if (type === 'team' && activeTeamId) {
      // eslint-disable-next-line @typescript-eslint/camelcase
      const search = useUrlSerach(history.location.search, { team_id: activeTeamId });
      history.replace(`${history.location.pathname}?${search}`);
    }
    if (type === 'scene' && activeOpensceneId) {
      // eslint-disable-next-line @typescript-eslint/camelcase
      const search = useUrlSerach(history.location.search, { openscene_id: activeOpensceneId });
      history.replace(`${history.location.pathname}?${search}`);
    }
  }, [activeTeamId, activeOpensceneId]);

  const onChange = useCallback((id) => {
    if (type === 'team') {
      golbal.activeTeamId = id;
      golbal.activeTeamInfo = golbal.teamList.find((item) => item.id === id) as TeamListData;
    }
    if (type === 'scene') {
      golbal.activeOpensceneId = id;
      golbal.activeOpensceneInfo = golbal.openSceneList.find((item) => item.id === id) as OpensceneData;
    }
  }, []);

  const jump = useCallback(() => {
    let url = '';
    if (type === 'team') {
      if (golbal.user.isSuperAdmin) {
        url = '/gateway/business/team';
      } else {
        url = '/gateway/team/join';
      }
    }
    if (type === 'scene') {
      if (golbal.user.isSuperAdmin) {
        url = '/gateway/business/openscene';
      } else {
        url = '/gateway/openscene/join';
      }
    }

    window.location.href = `${window.location.origin}${url}`;
  }, [type]);

  const renderJumpBtn = useCallback(() => {
    if (type === 'team') {
      if (golbal.user.isSuperAdmin) {
        return t('team_manager_go');
      }
      return t('all_team_go');
    }
    if (type === 'scene') {
      if (golbal.user.isSuperAdmin) {
        return t('openscene_manager_go');
      }
      return t('all_openscene_go');
    }
  }, [type]);

  return (
    <div className={styles.paltInfo}>
      <div className={styles.line} />
      <RimlessSelect
        size="md"
        width="auto"
        value={value}
        popoverWidth={180}
        onValueChange={onChange}
        popoverClassName={styles.popover}
        renderTrigger={(val, bool) => (
          <div className={styles.select}>
            <span className={styles.selectTitle}>{val?.label}</span>
            <DownOne
              theme="filled"
              className={`${styles.flag} ${bool && styles.active}`}
            />
          </div>
        )}
      >
        <div
          className={styles.innerScroll}
          ref={createScrollEvent}
        >
          {list.map((item) => <Select.Option key={item.id} value={item.id} label={item.name} />)}
          <div className={styles.all} onClick={jump}>
            <div>
              {renderJumpBtn()}
              <Right size={18} />
            </div>
          </div>
        </div>
      </RimlessSelect>
    </div>
  );
};

export default React.memo(observer(SelectMore));
